import React, { Component } from 'react';
import { ClaimsCards }      from './ClaimsCards';
import { ClaimsOptions }    from './ClaimsOptions';
import AuthService          from 'services/auth.service';
import ClaimsService        from 'services/claims.service';
import queryString          from 'query-string';
import moment               from 'moment';
import Search               from 'assets/icons/Search.svg';

const location = AuthService.getPracticeLocation();

class Claims extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page:         this.props.params.page || 1,
      total_pages:  1,
      per:          10,
      search:       this.props.params.search,
      items:        [],
      start_date:   this.props.params.start_date,
      end_date:     this.props.params.end_date,
      stats: {
        stats_approved: 0,
        stats_pending_submission: 0,
        stats_pending_approval: 0,
        stats_rejected: 0
      }
    };
  }

  reloadList() {
    const parameters = queryString.stringify({
      page:                 this.state.page,
      per:                  this.state.per,
      practice_location_id: location?.id,
      start_date:           this.state.start_date,
      end_date:             this.state.end_date,
      search:               this.state.search,
      status:               this.state.status,
      amount:               this.state.amount,
      category:             this.state.category
    });

    ClaimsService.list(parameters).then(
      (data) => {
        const meta = data.metadata;

        const stats = {
          stats_approved:           meta.approved,
          stats_pending_submission: meta.pending_submission,
          stats_pending_approval:   meta.pending_approval,
          stats_rejected:           meta.rejected
        }

        this.setState({
          page:         meta.current_page,
          total_pages:  meta.total_pages,
          stats:        stats,
          items:        data.claims
        });
      },
      (error) => {
        console.log(error.response);

        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  };

  componentDidMount() {
    this.reloadList();
  }

  handlePage(previous) {
    var pageNumber    = this.state.page;
    const totalPages  = this.state.total_pages;

    if (previous) {
      pageNumber = pageNumber === 1 ? 1 : pageNumber - 1;
    } else {
      pageNumber = pageNumber === totalPages ? totalPages : pageNumber + 1;
    }

    this.setState({ page: pageNumber }, this.reloadList);
  }

  updateDateRange(start_date, end_date) {
    let parseStartDate;
    let parseEndDate;

    if (start_date === 'skip') {
      parseStartDate = this.state.start_date;
    } else {
      parseStartDate = start_date ? moment(start_date).format('DD/MM/YYYY') : '';
    }

    if (end_date === 'skip') {
      parseEndDate = this.state.end_date;
    } else {
      parseEndDate = end_date ? moment(end_date).format('DD/MM/YYYY') : '';
    }

    this.setState({
      page: 1,
      start_date: parseStartDate,
      end_date: parseEndDate,
    }, this.reloadList);
  }

  handleEnterKey(e) {
    if (e.key === 'Enter') {
      this.setState({
        page: 1
      }, this.reloadList);
    }
  }

  updateFilters(status, amount, category) {
    this.setState({
      page: 1,
      status: status,
      amount: amount,
      category: category
    }, this.reloadList);
  }

  render() {
    return (
      <div id="main-content-target">
        <div className="d-sm-flex justify-content-between align-items-end">
          <h1 className="text-danger mb-4">Claims</h1>

          <span className="search-box d-block d-sm-inline-block">
            <img src={ Search } alt="search-icon" id="search-icon" />

            <input
              type="text"
              placeholder="Search"
              className="form-control rounded-pill"
              value={ this.state.search }
              onChange={(e) => this.setState({ search: e.target.value }) }
              onKeyDown={(e) => this.handleEnterKey(e) }
            />
          </span>
        </div>

        <div>
          <ClaimsOptions
            page={ this.state.page }
            total_pages={ this.state.total_pages }
            stats={ this.state.stats }
            prevPage={() => this.handlePage(true) }
            nextPage={() => this.handlePage(false) }
            startDate={ this.state.start_date }
            endDate={ this.state.end_date }
            changeDate={(start_date, end_date) => this.updateDateRange(start_date, end_date) }
            changeFilters={(status, amount, category) => this.updateFilters(status, amount, category) }
          />

          <ClaimsCards items={ this.state.items } handleReload={() => this.reloadList() } />
        </div>
      </div>
    )
  }
}

export default Claims;